// src/components/ReceiptModal.jsx
import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import "../Wallet/ReceiptModal.css"; // Agar custom styling alag rakhni ho
import APIDataFetchLoader from "../Others/APIDataFetchLoader";
import NotifyMessageNoReload from "../Others/NotifyMessageNoReload";
import { useAuth } from "../../Store/AuthContext";
import { formatPrice } from "../Others/ImportantFunction";

export default function PaymentSuccessReciptMoudle({
  show,
  onClose,
  Paymentdata,
  paid_type_status,
  showBordersStyle,
  showTextStyle,
}) {
  const { webSetting } = useAuth();
  // const ImageShowimage = ShowImagePath(
  //   webSetting.file_path,
  //   webSetting.header_logo
  // );

  const receiptRef = useRef(null);
  //   const { webSetting } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleDownloadPDF = async () => {
    try {
      setLoading(true); // 👈 loader start
      const element = receiptRef.current;

      const canvas = await html2canvas(element, {
        scale: 2,
        ignoreElements: (el) => el.classList.contains("exclude-pdf"),
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`transaction_${Paymentdata.order_id}.pdf`);
      NotifyMessageNoReload("Download Successfully !", "success");
    } catch (error) {
      console.error("PDF Download Error:", error);
    } finally {
      setLoading(false); // 👈 loader stop
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }

  //   const ImageShowimage = ShowImagePath(
  //     webSetting.file_path,
  //     webSetting.footer_logo
  //   );

  return (
    <div className="receipt-overlay">
      <div className="receipt-modal" ref={receiptRef}>
        {/* Header */}
        <div className="receipt-header">
          <h4>PAYMENT RECEIPT</h4>
          <p>Official Transaction Confirmation</p>
          {/* <div className="sitelogo">
            <img
              src={webSetting.footer_logo && ImageShowimage}
              alt=""
              title=""
              className="moudleLogo"
            />
          </div> */}
          {/* <div className="transactionbox">
            <div className="receipt-row">
              <span>Receipt No.</span>
              <span>{transaction.receipt_no}</span>
            </div>
            <div className="receipt-row">
              <span>Transaction Date</span>
              <span>{transaction.payment_date}</span>
            </div>
          </div> */}
        </div>
        <div className="receiptdivider m-0">
          <span className="divider-text"></span>
        </div>
        {/* Body */}
        <div className="receipt-body">
          <div className="transactionbox">
            {Paymentdata.recept_no && (
              <div className="receipt-row">
                <span className="receptFirst">Receipt ID</span>
                <span className="receptSecond">{Paymentdata.recept_no}</span>
              </div>
            )}
            {Paymentdata.payu_txnid && (
              <div className="receipt-row">
                <span className="receptFirst">Transaction ID</span>
                <span className="receptSecond">{Paymentdata.payu_txnid}</span>
              </div>
            )}
          </div>

          <div className="receiptdivider mt-4">
            <span className="divider-text">Transaction Details</span>
          </div>

          <div className="receipt-amount">
            <span className={`transAmount ${showTextStyle}`}>
              {`₹${Paymentdata.totalamount}`}
            </span>
            {paid_type_status}
          </div>

          {Paymentdata.order_id && (
            <div className="receipt-row">
              <span className="receptFirst">Order ID</span>
              <span className="receptSecond"> {Paymentdata.order_id}</span>
            </div>
          )}
          {/* {Paymentdata.payu_txnid && (
            <div className="receipt-row">
              <span className="receptFirst">Transaction ID</span>
              <span className="receptSecond">{Paymentdata.payu_txnid}</span>
            </div>
          )} */}

          {Paymentdata.seller_user_id && (
            <div className="receipt-row">
              <span className="receptFirst">Seller User ID</span>
              <span className="receptSecond">{Paymentdata.seller_user_id}</span>
            </div>
          )}
          {Paymentdata.account_id && (
            <div className="receipt-row">
              <span className="receptFirst">Account ID</span>
              <span className="receptSecond">{Paymentdata.account_id}</span>
            </div>
          )}

          {Paymentdata.payment_mode && (
            <div className="receipt-row">
              <span className="receptFirst">Payment Method</span>
              <span className="receptSecond">{Paymentdata.payment_mode}</span>
            </div>
          )}

          {Paymentdata.credit_debit && (
            <div className="receipt-row">
              <span className="receptFirst">Payment Staus</span>
              <span
                className={`badge ${
                  Paymentdata.credit_debit === "1" ? "bg-info" : "bg-danger"
                }`}
              >
                {Paymentdata.credit_debit === "1" ? "Credit" : "Debit"}
              </span>
            </div>
          )}
          {Paymentdata.discountamount === "0" && (
            <div className="receipt-row">
              <span className="receptFirst">Amount</span>
              <span className={`receptSecond ${showTextStyle}`}>
                ₹{Paymentdata.amount}
              </span>
            </div>
          )}
          {Paymentdata && Paymentdata.discountamount !== "0" && (
            <div className="receipt-row">
              <span className="receptFirst">Discount</span>
              <span className={`receptSecond`}>
                ₹{Paymentdata.discountamount}
              </span>
            </div>
          )}

          <div className="receipt-row">
            <span className="receptFirst">Status</span>
            <span className="receptSecond"> {paid_type_status}</span>
          </div>

          <div className="receiptdivider my-4">
            <span className="divider-text">Customer Information</span>
          </div>
          {Paymentdata.user_name && (
            <div className="receipt-row">
              <span className="receptFirst">Name</span>
              <span className="receptSecond">
                {Paymentdata.user_name || "N/A"}
              </span>
            </div>
          )}
          {Paymentdata.user_number && (
            <div className="receipt-row">
              <span className="receptFirst">Mobile Number</span>
              <span className="receptSecond">{Paymentdata.user_number}</span>
            </div>
          )}
          {Paymentdata.user_email && (
            <div className="receipt-row">
              <span className="receptFirst">Email</span>
              <span className="receptSecond">{Paymentdata.user_email}</span>
            </div>
          )}
          {Paymentdata.user_address && (
            <div className="receipt-row">
              <span className="receptFirst">Address</span>
              <span className="receptSecond">{Paymentdata.user_address}</span>
            </div>
          )}

          {/* //Seller Impormation */}
          <div className="receiptdivider my-4">
            <span className="divider-text">Seller Information</span>
          </div>
          {Paymentdata.seller_name && (
            <div className="receipt-row">
              <span className="receptFirst">Name</span>
              <span className="receptSecond">
                {Paymentdata.seller_name || "N/A"}
              </span>
            </div>
          )}
          {Paymentdata.seller_number && (
            <div className="receipt-row">
              <span className="receptFirst">Mobile Number</span>
              <span className="receptSecond">{Paymentdata.seller_number}</span>
            </div>
          )}
          {Paymentdata.seller_email && (
            <div className="receipt-row">
              <span className="receptFirst">Email</span>
              <span className="receptSecond">{Paymentdata.seller_email}</span>
            </div>
          )}
          {Paymentdata.seller_address && (
            <div className="receipt-row">
              <span className="receptFirst">Address</span>
              <span className="receptSecond">{Paymentdata.seller_address}</span>
            </div>
          )}

          {/* Paymnet Summery */}
          {Paymentdata && Paymentdata.discountamount !== "0" && (
            <div className="payment-summary">
              <h3>Payment Summary</h3>
              <div className="summary-row">
                <span className="summeryFtitle">Amount:</span>
                <span className="summeryAmtitle">
                  {formatPrice(Paymentdata.amount || "0")}
                </span>
              </div>
              {Paymentdata.discountamount !== "0" && (
                <div className="summary-row">
                  <span className="summeryFtitle text-danger">Discount:</span>
                  <span className="summeryAmtitle text-danger">
                    {formatPrice(Paymentdata.discountamount)}
                  </span>
                </div>
              )}
              <div className="summary-row">
                <span>Total Amount Paid:</span>
                <span> {formatPrice(Paymentdata.totalamount || 0)}</span>
              </div>
            </div>
          )}
          <div className="receipt-secured">
            <span>🔒 Secured Transaction</span>
            <span>✔ Verified Payment</span>
          </div>
        </div>

        {/* Footer */}
        <div className="receipt-footer">
          <p className="mb-1">
            Thank you for choosing {webSetting?.website_name || "YourDoorstep"}
          </p>
          <span>
            This is a computer generated receipt. No signature required.
            <br />
            For any queries, contact{" "}
            <b>{webSetting?.email || "support@example.com"}</b> or call{" "}
            <b>{webSetting?.mobile_number || "+91 0000000000"}</b>
          </span>
        </div>

        {/* Actions */}
        <div className="receipt-actions exclude-pdf">
          <button
            onClick={onClose}
            className="theme-btn btn-style-three submitbtn"
            disabled={loading}
          >
            Close
          </button>
          <button
            onClick={handleDownloadPDF}
            className="btn-download"
            disabled={loading}
          >
            {loading ? "Downloading..." : "Download"}
          </button>
        </div>
      </div>
    </div>
  );
}
